import React, { FC } from "react";
import { ButtonChat } from "src/components/ButtonChat";
import { getImageUrl } from "src/utils/getImageUrl";

interface Props {
  main_photo?: string;
  title: string;
  chatId: number;
}

export const DefaultDealRequestHead: FC<Props> = ({
  title,
  main_photo,
  chatId,
}) => (
  <div className="flex flex-col xl:flex-row xl:h-14 bg-gray-light rounded-20">
    {main_photo && (
      <div className="w-full xl:w-80">
        <img
          className="w-full h-full object-cover object-center rounded-20"
          src={getImageUrl(main_photo)}
          alt={title}
        />
      </div>
    )}

    <div className="flex flex-1 justify-between gap-8 pl-8">
      <h4 className="flex-1 self-center line-clamp-2" title={title}>
        {title}
      </h4>
      <ButtonChat chatId={chatId} isActiveStatus />
    </div>
  </div>
);
